var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1876 15.5L7.16675 10.4792L12.1876 5.45834L13.0834 6.35418L8.95841 10.4792L13.0834 14.6042L12.1876 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/paginationLeft.3c4c2d345d9b39d5255014f4b385c1ca.svg";
export { ForwardRef as ReactComponent };